// 引入axios
import axios from 'axios';
import qs from 'qs'


let baseUrl = "";
// 创建axios实例
const httpService = axios.create({
    baseURL: baseUrl,
    timeout: 1000 * 60 * 30, // 30分钟超时（大文件上传需要）
    paramsSerializer: params => qs.stringify(params, { indices: false })
});

// 添加请求拦截器
httpService.interceptors.request.use(function (config) {
    // 设置token
    config.headers.AUTHORIZATION = window.sessionStorage.getItem('token');

    // 处理用户信息
    const userStr = window.sessionStorage.getItem('user');
    if (userStr && typeof userStr === 'string') {
        try {
            config.headers['X-User-Info'] = encodeURIComponent(userStr);
        } catch (error) {
            console.error('用户信息编码失败:', error);
            delete config.headers['X-User-Info'];
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
httpService.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

/* 网络请求方法 */

// GET请求
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'get',
            params: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// POST请求
export function post(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'post',
            data: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// 新增：PUT请求（用于更新资源）
export function put(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'put', // 方法类型为PUT
            data: params   // 数据通过data传递（与POST一致）
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// DELETE请求
export function del(url, params = {}) {
    return new Promise((resolve, reject) => {
        httpService({
            url: url,
            method: 'delete',
            data: params
        }).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
}

// 文件上传
export function fileUpload(url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    httpService({
      url: url,
      method: 'post',
      data: params,
      ...config
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    });
  });
}

export function getServerUrl() {
    return baseUrl;
}

export default {
    get,
    post,
    put,  // 导出PUT方法
    del,
    fileUpload,
    getServerUrl
}
